import _ from '../../core/utils'
const accordionConfig = {
    accordions: _.selectAll( '.besa__accordion' )
}
export default accordionConfig